import EurekaHeader from 'ui-theme/components/header/js/header';
import Base from '../../ts/_base';
import Multi from '../../ts/_multi-inherit';
  
class Header extends Multi(EurekaHeader, Base) {

    protected initialThemeState: string;

    constructor(headerElement: HTMLElement, $document: JQuery<Document> = $(document), options :any  = { fixHeaderOnScrollUp: true }) {
        //@ts-ignore
        super(headerElement,$document, options);
        this.initialThemeState = this.headerTheme;
        this.handleCollapseClosing.bind(this);
        this.onDropdownOverT.bind(this);
        this.handleOutsideClick();
    } 
    
    get ChildClassList(): {[key: string]: string} { 
        return {
            ...this.classList,
            BG_DARK: 'bg-dark',
            fixed: 'navbar-fixed',
            fixedVisible: 'navbar-fixed--visible',
            fixedTransition: 'navbar-fixed--transition',
        }
    }

    get ChildSelectors(): {[key: string]: string} {
        return {
            ...this.selectors,
            sideMenu: '.side-menu',
            quickSearchDesktopTrigger: '.main-menu__right-content .quick-search__trigger',
            quickSearchMobileTrigger: '.navbar-toggler__container .quick-search__trigger',
            quickSeachHeaderExpand: '.header-quick-search',
        }
    }

    get headerTheme() {
        const { navBarContainer } = this._elements;
        return navBarContainer.classList.contains(this.ChildClassList.NAV_LIGHT) ? 'LIGHT' : 'DARK';
    }
    initDropdowns(dropdowns) {
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('mouseenter', this.onDropdownOverT.bind(this));
            dropdown.addEventListener('mouseleave', this.onDropdownOut);
        });
    }

    destroyDropdowns(dropdowns) {
        dropdowns.forEach(dropdown => {
            dropdown.removeEventListener('mouseenter', this.onDropdownOverT.bind(this));
            dropdown.removeEventListener('mouseleave', this.onDropdownOut);
        });
    }
    protected get navbarContainerHeight(): number {
        const { navBarContainer } = this._elements;
        const {height} = navBarContainer.getBoundingClientRect();
        return height;
    }

    protected get isFrezeed(): boolean {
        const { navBarContainer } = this._elements;
        return navBarContainer.classList.contains(this.ChildClassList.fixed);
    }

    initialize() {
        super.initialize.apply(this, arguments);
        this.sideMenuInteractionController();
        this.headerScrollJHandler();
    }

    setElements(headerElement) {
        super.setElements.apply(this, arguments);
        this._elements.sideMenu = headerElement.querySelector(this.ChildSelectors.sideMenu);
    }
    applyLightTheme() {
        const { navBarContainer } = this._elements;
        navBarContainer.classList.add(this.ChildClassList.NAV_LIGHT);
        navBarContainer.classList.add(this.ChildClassList.BG_LIGHT);
        navBarContainer.classList.remove(this.ChildClassList.BG_DARK);
        navBarContainer.classList.remove(this.ChildClassList.NAV_DARK);
    }
    applyDarkTheme() {
        const { navBarContainer } = this._elements;
        navBarContainer.classList.remove(this.ChildClassList.NAV_LIGHT);
        navBarContainer.classList.remove(this.ChildClassList.BG_LIGHT);
        navBarContainer.classList.add(this.ChildClassList.BG_DARK);
        navBarContainer.classList.add(this.ChildClassList.NAV_DARK);
    }

    sideMenuInteractionController() {
        this.subscribeToEvent('slider.show', () => {
            this.applyLightTheme();
        });

        this.subscribeToEvent('slider.hide', () => {
            if(this.initialThemeState === 'DARK')
                this.applyDarkTheme();
        });
    }
    async freezeHeader() {
        if(this.isFrezeed)
            return;
        //add padding to parant
        const { navBarContainer } = this._elements;
        this.navbarContainerHeight;
        const {parentElement} = navBarContainer;
        let padding = parseFloat(getComputedStyle(parentElement).paddingTop.replace('px', ''));
        padding += this.navbarContainerHeight;
        navBarContainer.parentElement.style.paddingTop = `${padding}px`;
        //add fixed class to navbar
        navBarContainer.classList.add(this.ChildClassList.fixed);
        //make it white
        this.applyLightTheme();
        //add visible class to navbar
        setTimeout(() => {
            if(this.isFrezeed)
                navBarContainer.classList.add(
                    this.ChildClassList.fixedTransition,
                    this.ChildClassList.fixedVisible
                );
        }, 400);
    }

    

    unfreezeHeader(fast: boolean = false) {
        if(!this.isFrezeed)
            return;
        //add padding to parant
        const { navBarContainer } = this._elements;
        this.navbarContainerHeight;
        const {parentElement} = navBarContainer;
        let padding = parseFloat(getComputedStyle(parentElement).paddingTop.replace('px', ''));
        padding -= this.navbarContainerHeight;
        //add fixed class to navbar
        navBarContainer.classList.remove(this.ChildClassList.fixedVisible);
        //add visible class to navbar
        setTimeout(()=> {
            navBarContainer.parentElement.style.paddingTop = `${Math.round(padding)}px`;
            navBarContainer.classList.remove(
                this.ChildClassList.fixedTransition, 
                this.ChildClassList.fixed
                );
            //back to initial state
            if(this.initialThemeState === 'DARK')
                this.applyDarkTheme();
        }, fast ? 100 : 400);

    }


    headerScrollJHandler() { 
        if(!this.deactivateFreezedHeader)
        this.utils.scroll.scrollEvent.subscribe((e) => {
            const isScrolledTop = (e.scrolledDistance - this.navbarContainerHeight - 300) <= 0;
            if(isScrolledTop)
                this.unfreezeHeader(true);
            else if(e.isUp) 
                this.freezeHeader();
            else if(e.distance > 100) 
                this.unfreezeHeader();
        });
    }
    handleCollapseClosing():void {
        let collapseEle =  $('[data-parent=".headerParentClass-e184595"]');
        if (!collapseEle.hasClass('show')) {
            setTimeout(()=> {(<any>$(collapseEle)).collapse('hide')}, 350)
        } else {
            (<any>$(collapseEle)).collapse('hide');
        }
    }
    // TODO refactor the following codes
    onDropdownOverT(e) {
        if (!e.target.classList.contains('show')) {
            const toggler = e.target.children[0];
            (<any>$(toggler)).dropdown('toggle');
        }
        this.handleCollapseClosing();
    }

    handleOutsideClick() {
        document.addEventListener('click', (e:Event) =>{
            let target = e.target as HTMLElement;
            let toggleType = target.closest('[data-toggle="collapse"]');
            let targetType = target.closest('[data-parent=".headerParentClass-e184595"]')
            if(!toggleType && !targetType){
                this.handleCollapseClosing();
            }
        })
    }

    initQuickSearchLinks() { }
    destroyQuickSearchLinks() { }
    responsiveMenuControl() { }
    get deactivateFreezedHeader(): boolean {
        const article = this.queryElm('article');
        if(article) return true;
        return false
    }
}

export default Header;
